const meeting_manage = [
    { path: 'meeting-manage/CreatingMeeting', meta: { name: "创建会议" } },
]

export default meeting_manage


// WEBPACK FOOTER //
// ./src/router/mapping/meeting-manage.js